<template>
  <button class="charla__border__button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "HeaderBorderButton"
}
</script>

<style scoped lang="scss">
  @import "@/scss/mixins";

  .charla__border__button{
    padding: 9px 10px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0px;
    background-color: white;
    border: 1px solid rgb(0, 0, 0);
    border-radius: 20px;
    //width: adapt(120px, 60px, 60);
    width: 100%;
    transition: 300ms ease all;

    &:hover{
      background-color: black;
      color: white;
    }
  }
</style>